import { Branch, User, PaymentBatch, AuditEntry, PaymentRecord } from '../types'

// Mock Branches (Pakistani Cities)
export const mockBranches: Branch[] = [
  {
    id: 'b1',
    branchCode: 'ISL001',
    branchName: 'Islamabad Main',
    city: 'Islamabad',
    region: 'Federal',
    address: 'Blue Area, Jinnah Avenue, Islamabad',
    email: 'isl.main@cdns.gov.pk',
    phone: '051-9201234',
    iban: 'PK36CDNS0000000100000001',
    ibanTitle: 'CDNS ISLAMABAD OPS',
    status: 'Active',
    createdAt: '2023-01-01T00:00:00Z',
    approvalStatus: 'Approved',
  },
  {
    id: 'b2',
    branchCode: 'LHR002',
    branchName: 'Lahore Gulberg',
    city: 'Lahore',
    region: 'Punjab',
    address: 'Main Boulevard, Gulberg III, Lahore',
    email: 'lhr.gulberg@cdns.gov.pk',
    phone: '042-35712345',
    iban: 'PK36CDNS0000000200000002',
    ibanTitle: 'CDNS LAHORE OPS',
    status: 'Active',
    createdAt: '2023-01-15T00:00:00Z',
    approvalStatus: 'Approved',
  },
  {
    id: 'b3',
    branchCode: 'KHI003',
    branchName: 'Karachi Saddar',
    city: 'Karachi',
    region: 'Sindh',
    address: 'Zaibunnisa Street, Saddar, Karachi',
    email: 'khi.saddar@cdns.gov.pk',
    phone: '021-35612345',
    iban: 'PK36CDNS0000000300000003',
    ibanTitle: 'CDNS KARACHI OPS',
    status: 'Active',
    createdAt: '2023-02-01T00:00:00Z',
    approvalStatus: 'Approved',
  },
  {
    id: 'b4',
    branchCode: 'PES004',
    branchName: 'Peshawar Cantt',
    city: 'Peshawar',
    region: 'KPK',
    address: 'Saddar Road, Peshawar Cantt',
    email: 'pes.cantt@cdns.gov.pk',
    phone: '091-5271234',
    iban: 'PK36CDNS0000000400000004',
    ibanTitle: 'CDNS PESHAWAR OPS',
    status: 'Active',
    createdAt: '2023-02-15T00:00:00Z',
    approvalStatus: 'Approved',
  },
  {
    id: 'b5',
    branchCode: 'QTA005',
    branchName: 'Quetta Jinnah Road',
    city: 'Quetta',
    region: 'Balochistan',
    address: 'Jinnah Road, Quetta',
    email: 'qta.jinnah@cdns.gov.pk',
    phone: '081-9201234',
    iban: 'PK36CDNS0000000500000005',
    ibanTitle: 'CDNS QUETTA OPS',
    status: 'Active',
    createdAt: '2023-03-01T00:00:00Z',
    approvalStatus: 'Approved',
  },
]

// Mock Users
export const mockUsers: User[] = [
  {
    id: 'u1',
    fullName: 'Ahmed Khan',
    email: 'admin.maker@cdns.gov.pk',
    mobile: '0300-1234567',
    cnic: '35202-1234567-1',
    branchId: 'b1',
    role: 'AdminMaker',
    status: 'Active',
    createdAt: '2023-01-01T00:00:00Z',
    approvalStatus: 'Approved',
  },
  {
    id: 'u2',
    fullName: 'Sara Ali',
    email: 'admin.checker@cdns.gov.pk',
    mobile: '0321-7654321',
    cnic: '61101-7654321-2',
    branchId: 'b1',
    role: 'AdminChecker',
    status: 'Active',
    createdAt: '2023-01-01T00:00:00Z',
    approvalStatus: 'Approved',
  },
  {
    id: 'u3',
    fullName: 'Bilal Ahmed',
    email: 'branch.maker@cdns.gov.pk',
    mobile: '0333-9876543',
    cnic: '42201-9876543-3',
    branchId: 'b2',
    role: 'BranchMaker',
    status: 'Active',
    createdAt: '2023-01-15T00:00:00Z',
    approvalStatus: 'Approved',
  },
  {
    id: 'u4',
    fullName: 'Zainab Bibi',
    email: 'branch.checker@cdns.gov.pk',
    mobile: '0345-1122334',
    cnic: '35201-1122334-4',
    branchId: 'b2',
    role: 'BranchChecker',
    status: 'Active',
    createdAt: '2023-01-15T00:00:00Z',
    approvalStatus: 'Approved',
  },
]

// Helper to generate mock records
const generateMockRecords = (
  batchId: string,
  count: number,
  status: any = 'Pending',
): PaymentRecord[] => {
  const banks = ['HBL', 'MCB', 'BAHL', 'UBL', 'NBP', 'MEZN', 'ABL', 'SCB']
  const names = [
    'Muhammad Ali',
    'Fatima Bibi',
    'Usman Khan',
    'Zainab Jameel',
    'Omar Farooq',
    'Ayesha Siddiqui',
    'Bilal Ahmed',
    'Hassan Raza',
  ]
  const purposes = [
    '1011',
    '1012',
    '1013',
    '1014',
    '1015',
    '1016',
    '1017',
    '1018',
  ]
  const purposeDescs = [
    'Monthly Salary Payment',
    'Vendor Supply Payment',
    'Monthly Pension',
    'Contractor Payment',
    'Utility Reimbursement',
    'Travel Allowance',
    'Medical Reimbursement',
    'Bonus Payment',
  ]
  const narrations = [
    'Salary Jan 2024',
    'Invoice INV-001',
    'Pension Jan 2024',
    'Contract Payment Q1',
    'Utility Bill Dec',
    'Travel Claim #45',
    'Medical Claim #12',
    'Eid Bonus 2024',
  ]

  return Array.from({ length: count }).map((_, i) => {
    // For batches with mixed results, make some records failed
    const isFailed = status === 'Completed' && i % 8 === 7
    const recordStatus = isFailed ? 'Failed' : status

    return {
      id: `${batchId}-rec-${i + 1}`,
      batchId,
      receiverIban: `PK36${banks[i % banks.length]}00000000${10000000 + i}`,
      receiverName: names[i % names.length],
      amount: Math.floor(Math.random() * 100000) + 5000,
      paymentPurpose: purposes[i % purposes.length],
      purposeDescription: purposeDescs[i % purposeDescs.length],
      narration: narrations[i % narrations.length],
      paymentReference: `REF-${batchId}-${String(i + 1).padStart(3, '0')}`,
      reserved1: '',
      reserved2: '',
      bankBic: banks[i % banks.length],
      titleFetchStatus: status === 'Pending' ? 'Pending' : 'Success',
      titleFetchResult:
        status === 'Pending'
          ? undefined
          : names[i % names.length].toUpperCase(),
      status: recordStatus,
    }
  })
}

// Mock Payment Batches
export const mockBatches: PaymentBatch[] = [
  {
    id: 'batch-001',
    fileName: 'salary_jan_2024.csv',
    uploadedBy: 'u3',
    branchId: 'b2',
    uploadDate: '2024-01-25T10:30:00Z',
    totalRecords: 15,
    validRecords: 15,
    failedRecords: 0,
    successfulRecords: 15,
    totalAmount: 1500000,
    status: 'Completed',
    records: generateMockRecords('batch-001', 15, 'Completed'),
  },
  {
    id: 'batch-002',
    fileName: 'vendor_payments_feb.xlsx',
    uploadedBy: 'u3',
    branchId: 'b2',
    uploadDate: '2024-02-10T14:15:00Z',
    totalRecords: 8,
    validRecords: 7,
    failedRecords: 1,
    totalAmount: 450000,
    status: 'ApprovalPending',
    records: generateMockRecords('batch-002', 8, 'ApprovalPending'),
  },
  {
    id: 'batch-003',
    fileName: 'pension_march_2024.csv',
    uploadedBy: 'u3',
    branchId: 'b2',
    uploadDate: '2024-03-05T09:00:00Z',
    totalRecords: 25,
    validRecords: 25,
    failedRecords: 0,
    totalAmount: 2500000,
    status: 'TitleFetchCompleted',
    records: generateMockRecords('batch-003', 25, 'TitleFetchCompleted'),
  },
  {
    id: 'batch-004',
    fileName: 'contractors_april_2024.xlsx',
    uploadedBy: 'u3',
    branchId: 'b2',
    uploadDate: '2024-04-01T11:20:00Z',
    totalRecords: 12,
    validRecords: 12,
    failedRecords: 0,
    totalAmount: 1200000,
    status: 'ApprovalPending',
    records: generateMockRecords('batch-004', 12, 'ApprovalPending'),
  },
  {
    id: 'batch-005',
    fileName: 'bonus_eid_2024.csv',
    uploadedBy: 'u3',
    branchId: 'b2',
    uploadDate: '2024-04-05T15:45:00Z',
    totalRecords: 50,
    validRecords: 48,
    failedRecords: 2,
    totalAmount: 5000000,
    status: 'PaymentInitiated',
    records: generateMockRecords('batch-005', 50, 'PaymentInitiated'),
  },
  {
    id: 'batch-006',
    fileName: 'rejected_batch_may.csv',
    uploadedBy: 'u3',
    branchId: 'b2',
    uploadDate: '2024-05-01T09:10:00Z',
    totalRecords: 5,
    validRecords: 5,
    failedRecords: 0,
    totalAmount: 250000,
    status: 'Rejected',
    rejectionReason:
      'Incorrect payment purpose codes used for vendor payments.',
    records: generateMockRecords('batch-006', 5, 'Rejected'),
  },
]

// Mock Audit Logs
export const mockAuditLogs: AuditEntry[] = [
  {
    id: 'aud-001',
    timestamp: '2024-03-10T08:30:00Z',
    userId: 'u1',
    userName: 'Ahmed Khan',
    ip: '192.168.1.10',
    device: 'Chrome / Windows',
    action: 'Login',
    module: 'Auth',
    entityId: 'u1',
  },
  {
    id: 'aud-002',
    timestamp: '2024-03-10T09:15:00Z',
    userId: 'u3',
    userName: 'Bilal Ahmed',
    ip: '192.168.2.5',
    device: 'Firefox / MacOS',
    action: 'Upload Batch',
    module: 'Payments',
    entityId: 'batch-003',
    afterValue: 'Batch Created: pension_march_2024.csv',
  },
  {
    id: 'aud-003',
    timestamp: '2024-03-10T09:20:00Z',
    userId: 'u3',
    userName: 'Bilal Ahmed',
    ip: '192.168.2.5',
    device: 'Firefox / MacOS',
    action: 'Initiate Title Fetch',
    module: 'Payments',
    entityId: 'batch-003',
    beforeValue: 'Pending',
    afterValue: 'TitleFetchInitiated',
  },
]
